import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import _ from 'lodash';
import SubClassificationModal from '../component/SubClassificationModal';
import * as actions from '../../../action';
import * as c from '../../../constant';

function LandSubClassContainer({
  classificationId,
  getSubClassificationsList,
  subClassificationsList,
  removeSubClass,
  classificationInfo,
  ordinanceRevisionId,
}) {
  const setModal = useContext(ModalContext);

  useEffect(() => {
    if (_.isEmpty(classificationId)) return;
    getSubClassificationsList(classificationId, {
      ordinance_revision_id: ordinanceRevisionId,
    });
  }, [classificationId, ordinanceRevisionId]);

  const addSubClass = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <SubClassificationModal
          type="NEW"
          classificationId={classificationId}
          ordinanceRevisionId={ordinanceRevisionId}
        />
      ),
      title: 'Add Land Sub Classification',
      modalSize: 'modal-md',
    });
  };

  const updateSubClass = (id, data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <SubClassificationModal
          updateList={data.attributes}
          id={data.id}
          type="EDIT"
          classificationId={classificationId}
        />
      ),
      title: 'Update Land Sub Classification',
      modalSize: 'modal-md',
    });
  };

  // const handleOnSubmit = (data) => {
  //   const args = {
  //     ...data,
  //     isPaginate: 1
  //   }
  //   getSubClassificationsList(classificationId, args);
  // };
  // const land_sub_class = _.get(classificationInfo, 'included.subClassifications')

  return (
    <div className="card">
      <div className="card-body">
        <div className="row d-flex justify-content-between align-items-center">
          <div className="col-10">
            <h3 className="">Information</h3>
          </div>
        </div>
        <hr />
        <div className="mt-1">
          <div className="row d-flex justify-content-center">
            <div className="col-12">
              <div className="form-wrapper mb-3">
                <div className="full-group ">
                  <div className="form-row">
                    <div className="form-input-group col-12 ">
                      <label className="full-label mb-0">
                        Classification Name:
                      </label>
                      <span className="full-input">
                        {_.get(classificationInfo, 'attributes.name') || '--'}
                      </span>
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-input-group col-12 ">
                      <label className="full-label mb-0">Description:</label>
                      <span className="full-input">
                        {_.get(classificationInfo, 'attributes.description') ||
                          '--'}
                      </span>
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-input-group col-12 ">
                      <label className="full-label mb-0">Is Active:</label>
                      <span className="full-input">
                        {_.get(classificationInfo, 'attributes.is_active')
                          ? 'YES'
                          : 'NO'}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row d-flex justify-content-center w-100 border-top">
              <div className="font-weight-bold col-12 mt-2 text-right">
                <button
                  type="button"
                  onClick={addSubClass}
                  className="btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold px-4"
                >
                  Add&nbsp;
                  <i className="fas fa-plus" />
                </button>
              </div>
            </div>
            <div className="row d-flex justify-content-center w-100">
              <div className="font-weight-bold col-12 mt-2 text-center">
                Land Sub Classifications
              </div>
              <div className="col-12">
                <table className="table table-striped table-borderless">
                  <thead>
                    <tr>
                      <th>Code</th>
                      <th>Description</th>
                      <th>Unit Value</th>
                      <th>Ordinance Revision</th>
                      <th />
                    </tr>
                  </thead>
                  <tbody>
                    {subClassificationsList && subClassificationsList.length ? (
                      subClassificationsList.map((subClass) => {
                        return (
                          <tr key={subClass.id}>
                            <td>{subClass.attributes.code}</td>
                            <td>{subClass.attributes.description}</td>
                            <td>{subClass.attributes.unit_value}</td>
                            <td>
                              {subClass.attributes.ordinance_revision_name}
                            </td>
                            <td>
                              <button
                                type="button"
                                className="btn-blank"
                                onClick={updateSubClass(
                                  classificationId,
                                  subClass
                                )}
                              >
                                <i className="far fa-edit icon-edit" />
                              </button>
                              <button
                                type="button"
                                className="btn-blank"
                                onClick={removeSubClass(subClass)}
                              >
                                <i className="far fa-trash-alt icon-delete" />
                              </button>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td>No Data</td>
                        <td />
                        <td />
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
LandSubClassContainer.defaultProps = {};

LandSubClassContainer.propTypes = {
  removeSubClass: PropTypes.instanceOf(Function).isRequired,
  getSubClassificationsList: PropTypes.instanceOf(Function).isRequired,
  subClassificationsList: PropTypes.instanceOf(Array).isRequired,
  classificationId: PropTypes.string.isRequired,
  ordinanceRevisionId: PropTypes.number.isRequired,
  classificationInfo: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  subClassificationsList:
    _.get(api, `${c.GET_LAND_SUB_CLASSIFICATIONS}.list`) || [],
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(LandSubClassContainer);
